export default "__VITE_ASSET__BMG9Wk5___"